module.exports = __webpack_public_path__ + "img/payment-method-boleto.02f8c3b8.svg";